/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareDownIcon20Light = forwardRef('ArrowFigureASquareDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 5.5a.5.5 0 0 1 .5.5v6.219l2.116-2.54a.5.5 0 1 1 .768.641l-2.232 2.678a1.5 1.5 0 0 1-2.304 0L6.116 10.32a.5.5 0 0 1 .768-.64L9 12.219V6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 2A3.5 3.5 0 0 1 17 5.5v8a3.5 3.5 0 0 1-3.5 3.5h-8A3.5 3.5 0 0 1 2 13.5v-8A3.5 3.5 0 0 1 5.5 2h8ZM16 5.5A2.5 2.5 0 0 0 13.5 3h-8A2.5 2.5 0 0 0 3 5.5v8A2.5 2.5 0 0 0 5.5 16h8a2.5 2.5 0 0 0 2.5-2.5v-8Z" })));
});
